import { useState } from "react";
import Sidebar from "./components/Sidebar";
import Topbar from "./components/Topbar";
import { Outlet } from "react-router-dom";

export default function AdminLayout() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="admin-root">
      <Sidebar open={menuOpen} onNavigate={() => setMenuOpen(false)} />

      {/* Tap anywhere outside the slide-in menu to dismiss it */}
      <div
        className={`admin-backdrop ${menuOpen ? 'show' : ''}`}
        onClick={() => setMenuOpen(false)}
      />

      <div className="admin-main">
        <Topbar onMenuToggle={() => setMenuOpen((o) => !o)} />
        <div className="admin-page">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
